import { cloneDeep } from 'lodash'
import {
  caseInsensitiveValueSorter,
  createdAtSorter,
  dateRenderer,
  entityNameSorter,
  getProp,
  updatedAtSorter
} from '@lib/generic.utils'
// Components
import AgGridSelect from '@components/ag-grid-helpers/AgGridSelect'
import LmEntityActions from '@components/ag-grid-helpers/EntityActions'

export default {
  computed: {
    agGridOptions() {
      return {
        rowData: cloneDeep(this.qualifierLabels?.labels),
        frameworkComponents: {
          'ag-grid-select': AgGridSelect
        },
        context: {
          actions: [
            {
              icon: 'trash',
              tooltip: 'Delete',
              onClick: this.delete,
              color: 'faded'
            }
          ]
        },
        columnDefs: [
          {
            headerName: 'Name',
            field: 'name',
            tooltipField: 'name',
            editable: true,
            cellRenderer: params => getProp(params, 'value'),
            comparator: caseInsensitiveValueSorter
          },
          {
            headerName: 'Term',
            field: 'term_label',
            editable: true,
            cellEditorParams: params => {
              return {
                options: this.termLabelOptions,
                optionValue: 'value',
                selected: {
                  label: params.data.term_label.name,
                  value: params.data.term_label.id
                },
                getValueFromParent: selected => {
                  const term_label = cloneDeep(params.data.term_label)
                  term_label.id = selected.value
                  term_label.name = selected.label
                  return term_label
                }
              }
            },
            cellEditor: 'ag-grid-select',
            cellRenderer: params => params.data.term_label.name,
            tooltipValueGetter: params => getProp(params.value, 'name'),
            width: 400,
            comparator: entityNameSorter
          },
          {
            headerName: 'Created',
            field: 'created_at',
            comparator: createdAtSorter,
            cellRenderer: params => dateRenderer(params.value),
            tooltipValueGetter: params => dateRenderer(params.value)
          },
          {
            headerName: 'Updated',
            field: 'updated_at',
            comparator: updatedAtSorter,
            cellRenderer: params => dateRenderer(params.value),
            tooltipValueGetter: params => dateRenderer(params.value)
          },
          {
            headerName: 'Actions',
            cellRendererFramework: LmEntityActions
          }
        ]
      }
    }
  }
}
